import {skuIsLoadedOrUnloadedVehicleSpecificEnclosure} from '../products/vehicle-specific.mjs';

export const getManufacturerMakeKeywordsForVsEnclosures = (sku) => {
  let keywords = [];
  const vs10or12SubwooferSkuList = ['VS-10 D2', 'VS-10 D4', 'VS-12 D2', 'VS-12 D4'];
  const notVsSubwoofer = !vs10or12SubwooferSkuList?.includes(sku);

  if (notVsSubwoofer && sku?.includes('VS-')) {
    Object.keys(skuToVsMappings).forEach((key) => {
      if (sku.includes(key)) {
        let mapping = skuToVsMappings[key];
        if (mapping) mapping = mapping.toLowerCase();
        keywords.push(mapping);
        if (mapping === 'gmc') {
          keywords.push('chevy');
          keywords.push('chevrolet');
        }
      }
    });
  }
  keywords = keywords?.map((keyword) => keyword?.toLowerCase());
  return keywords || [];
};

export const getKeywordsForTitlesOfVsEnclosures = (product) => {
  const keywordAssociations = [];
  const skuProperties = product?.properties;

  const model = skuProperties?.Model;
  if (!model) return keywordAssociations;
  let keywords = model?.split('|');
  keywords = keywords?.map((keyword) => keyword?.toLowerCase());
  // consoleLogLightYellowOrange(`  > [${product?.sku}] model:`, `${model}`);
  keywords.forEach((keyword) => {
    keywordAssociations.push(keyword);
  });
  // consoleLogLightYellowOrange(`  > [${product?.sku}] Keywords:`, `${keywordAssociations}\n`);
  return keywordAssociations;
};

export const getVsEnclosureYearsAndMakes = (product) => {
  const productProperties = product?.properties;
  const startYear = parseFloat(productProperties?.['Start Year'])
  const endYear = parseFloat(productProperties?.['End Year'])
  const make = productProperties?.['Make']

  let yearsAndMakes = [];

  if(startYear && endYear && make) {
    for(let year = startYear; year <= endYear; year++) {
      yearsAndMakes.push(`${year} ${make}`);

      let twoDigitYear = (year % 100).toString().padStart(2, '0');
      yearsAndMakes.push(`${twoDigitYear} ${make}`);

    }
  }

  return yearsAndMakes;
}

export const getSearchKeywordsBasedOnProductCategory = (product) => {
  const sku = product?.sku;
  const category = product?.category;

  if (skuIsLoadedOrUnloadedVehicleSpecificEnclosure(sku)) {
    return [];
  }

  let keywords = [];

  switch (category) {
    case 'sound-deadening':
      keywords = [
        'automotive sound deadening',
        'car sound deadener',
        'car sound deadening',
        'sound deadening',
        'sound deadener',
        'car sound dampening',
        'sound deadening mat',
        'sound deadening foam',
        'acoustic dampening material',
        'soundproofing insulation',
        'vibration dampening material',
        'noise reduction mat',
        'automotive soundproofing'
      ];
      break;
    case 'empty-subwoofer-enclosures':
      keywords = [
        'empty subwoofer enclosure',
        'empty sub enclosure',
        'subwoofer box',
        'sub box',
        'sub enclosures',
        'subwoofer boxes',
        'subwoofer enclosures',
        'sub enclosures'
      ];
      break;
    case 'complete-bass-package':
      keywords = [
        'bass package',
        'bass kit',
        'subwoofer kit',
        'bundle',
        'amp bundle',
        'amplifier bundle',
        'powerful bass',
        'bass system',
        'bass packages',
        'bass kits',
        'subwoofer kits',
        'amp bundles',
        'amplifier bundles',
        'powerful basses',
        'bass systems'
      ];
      break;
    case 'subwoofers':
      keywords = [
        'subwoofer',
        'subwoofers',
        'car subwoofer',
        'car subwoofers',
        'bass subwoofer',
        'bass subwoofers',
        'powerful subwoofer',
        'powerful subwoofers',
        'sub',
        'subs'
      ];
      break;
    case 'loaded-subwoofer-enclosures':
      keywords = [
        'loaded enclosure',
        'loaded subwoofer enclosure',
        'loaded sub enclosure',
        'loaded subwoofer box',
        'subwoofer enclosure kit',
        'subwoofer enclosure kits',
        'loaded enclosures',
        'loaded subwoofer enclosures',
        'loaded sub enclosures',
        'loaded subwoofer boxes',
        'subwoofer enclosure bundles',
        'subwoofer enclosure bundle',
        'loaded subwoofer enclosure bundles',
        'loaded subwoofer enclosure bundle',
        'bass enclosure bundle',
        'bass enclosure bundles'
      ];
      break;
    case 'speakers':
      keywords = [
        'speaker',
        'speakers',
        'car speaker',
        'car speakers',
        'speaker system',
        'speaker systems',
        'high-quality speakers',
        'high-quality speaker',
        'midrange speaker',
        'midrange speakers',
        'mid speakers',
        'midrange speakers',
        'mid-range speaker',
        'mid-range speakers',
        'midrange',
        'midranges'
      ];
      break;
    case 'bass-knob-remote-controls':
      keywords = [
        'bass knob',
        'bass knobs',
        'remote control',
        'remote controls',
        'audio control',
        'audio controls',
        'amplifier control',
        'amplifier controls',
        'bass control',
        'bass controls',
        'knob control',
        'knob controls'
      ];
      break;
    case 'amplifiers':
      keywords = [
        'amplifier',
        'car amplifier',
        'powerful car amp'
      ];
      break;
    case 'power-distribution-blocks':
      keywords = [
        'power distribution block',
        'distribution block',
        'power block',
        'amp power block',
        'distro block'
      ];
      break;
    case 'miscellaneous-accessories':
      keywords = [
        'miscellaneous accessory',
        'miscellaneous accessories',
        'car audio accessory',
        'car audio accessories',
        'accessory',
        'accessories',
        'parts',
        'part',
        'miscellaneous',
        'misc'
      ];
      break;
    case 'fuses':
      keywords = [
        'fuse',
        'fuse holder',
        'car fuse',
        'fuse protection',
        'amp fuse'
      ];
      break;
    case 'frequency-filters':
      keywords = [
        'filter',
        'frequency filter',
        'crossover',
        'audio filter',
        'sound filter',
        'crossover filter',
        'frequency',
        'frequencies'
      ];
      break;
    case 'electronics-equalizers-and-crossovers':
      keywords = [
        'electronics',
        'equalizer',
        'crossover',
        'eq',
        'component',
        'part',
        'accessory',
        'accessories',
        'electronics equalizer',
        'audio crossover',
        'eq component',
        'audio component',
        'electronic accessory',
        'electronic accessories'
      ];
      break;
    case 'amplifier-wiring-kits':
      keywords = [
        'wire kit',
        'amp wiring kit',
        'big 3 kit',
        'big three kit',
        'amp kit'
      ];
      break;
    case 'rca-interconnects':
      keywords = [
        'RCA interconnect',
        'RCA cable',
        'y adapter',
        'y-cable'
      ];
      break;
    case 'speaker-wire':
      keywords = [
        'speaker wire'
      ];
      break;
    case 'batteries':
      keywords = [
        'battery',
        'batteries',
        'AGM',
        'absorbent glass mat',
        'car audio battery',
        'car audio batteries',
        'xs power',
        'shuriken'
      ];
      break;
  }

  keywords = keywords?.map((keyword) => keyword?.toLowerCase());
  return keywords;
};

export const skuToVsMappings = {
  'GM-': 'GMC',
  'GMC-': 'GMC',
  'GMCSB-': 'GMC',
  'GMCCB-': 'GMC',
  'GMCCREW-': 'GMC',
  'HON-': 'HONDA',
  'TOY-': 'TOYOTA',
  'TOYCOR-': 'TOYOTA',
  'TOYTA-': 'TOYOTA',
  'TOYRUN-': 'TOYOTA',
  'TOYTAC-': 'TOYOTA',
  'TOYTUN-': 'TOYOTA',
  'TOYRAV-': 'TOYOTA',
  'TOYCAM-': 'TOYOTA',
  'TOY4RUNNER-': 'TOYOTA',
  'TOYRV4-': 'TOYOTA',
  'FORD-': 'FORD',
  'FOR-': 'FORD',
  'FORDSD-': 'FORD',
  'NIS-': 'NISSAN',
  'NISS-': 'NISSAN',
  'NISTTN-': 'NISSAN',
  'NISSAN-': 'NISSAN',
  'NISALT-': 'NISSAN',
  'NISFRONT-': 'NISSAN',
  'NISCREW-': 'NISSAN',
  'NISKC-': 'NISSAN',
  'CHEV-': 'CHEVY',
  'CHEVY-': 'CHEVY',
  'CHRY-': 'CHRYSLER',
  'DOD-': 'DODGE',
  'DODGE-': 'DODGE',
  'DODCHARG-': 'DODGE',
  'RAM-': 'RAM',
  'JEEP-': 'JEEP',
  'JGLADIATOR-': 'JEEP',
  'JW-': 'JEEP',
  'GLADIATOR-': 'JEEP',
  'LEX-': 'LEXUS',
  'SUB-': 'SUBARU',
  'AUD-': 'AUDI',
  'BMW-': 'BMW',
  'MER-': 'MERCEDES',
  'VW-': 'VOLKSWAGEN',
  'VOLK-': 'VOLKSWAGEN',
  'VOLKS-': 'VOLKSWAGEN',
  'INFIN-': 'INFINITI',
  'INFINIT-': 'INFINITI',
  'INFINITI-': 'INFINITI',
  'ACUR-': 'ACURA',
  'ACURA-': 'ACURA',
  'MAZ-': 'MAZDA',
  'MAZDA-': 'MAZDA',
  'KIA-': 'KIA',
  'HYUN-': 'HYUNDAI',
  'HYUNDAI-': 'HYUNDAI',
  'POR-': 'PORSCHE',
  'PORSCHE-': 'PORSCHE',
  'PORSC-': 'PORSCHE',
  'TES-': 'TESLA',
  'TESLA-': 'TESLA'
};
